import './App.css'

function App() {

  return (
    <div>
      <header>
        <h1>Política de Privacidade</h1>
        <h2>PLATAFORMA PARKO</h2>
      </header>
      <br/>
      <div>
        <h3>1. DAS INFORMAÇÕES GERAIS</h3>
        <p>A presente Política de Privacidade tem por objetivo apresentar informações sobre a coleta, o uso, o armazenamento, o tratamento e a proteção dos dados dos usuários/clientes do sistema de gerenciamento de estacionamento e reserva de vagas Parko. Esse documento demonstra de forma clara e transparente todos os tipos de dados que serão coletados, os motivos de coleta desses dados e as formas de gerenciamento ou exclusão das informações pessoais dos usuários.</p>
        <p>Essa Política de Privacidade aplica-se a todos os usuários da plataforma Parko e integra os Termos e Condições Gerais de Uso dessa plataforma, devidamente e legalmente representada pela, <strong>PARKO SOLUCOES TECNOLOGICAS LTDA</strong>, inscrito no CNPJ sob o nº 55.063.299/0001-15, residente e domiciliado na Rua Doutor José Peroba, 297, Edif. Atlanta Empresarial Sala 1105, Stiep, CEP 41.770-235, Salvador-BA, doravante denominado <strong>CONTRATADA</strong>.</p>
        <p>Vale salientar que o presente documento pode sofrer alterações em decorrência de eventual(is) atualização(ões) normativa(s). Sendo assim, recomenda-se ao usuário a consulta periódica deste contrato.</p>
      </div>
      <div>
        <h3>2. DO RECOLHIMENTO DOS DADOS DOS USUÁRIOS </h3>
        <p>O recolhimento dos dados cadastrais dos usuários ocorre da seguinte forma:</p>
        <ol type="I">
          <li>Quando criada a conta na plataforma Parko, o usuário deve cadastrar dados básicos de identificação pessoal, dentre eles o nome e o sobrenome, o número de telefone, o endereço eletrônico e a senha e o número do CPF. A partir do preenchimento desta seção, pode-se garantir uma maior segurança na gestão dos dados do usuário e maior facilidade tanto em contato quanto em suporte caso haja necessidade. </li>
          <li>Quando o usuário acessa a sua conta no aplicativo Parko e realiza a reserva da vaga no estacionamento do estabelecimento escolhido, a plataforma calcula o tempo de permanência do veículo no local considerando estritamente os horários de chegada e de saída do cliente no estabelecimento dentro do prazo de tolerância estipulado pela empresa parceira. Dessa forma, haverá um controle e uma aplicação mais assertivos das premissas de operacionalidade estabelecidas no Termo e Condições Gerais de Uso da plataforma Parko.</li>
        </ol>
      </div>
      <div>
        <h3>3. DOS TIPOS DE DADOS RECOLHIDOS DOS USUÁRIOS</h3>
        <p>Os dados pessoais dos usuários são dos seguintes tipos:</p>
        <ol type="I">
          <li>DADOS PARA A CRIAÇÃO DA CONTA NA PLATAFORMA PARKO: constam no tópico I da cláusula 2 deste documento.</li>
          <li>DADOS FINANCEIROS: Cartões de crédito, débito e chaves PIX. </li>
          <li>DADOS DE FEEDBACK/AVALIAÇÕES: Após o uso do serviço, pelo cliente  B2C e B2B, poderão ser coletados dados de feedbacks e avaliações acerca do aplicativo/serviço. </li>
        </ol>
        <p>Serão coletados os seguintes dados pessoais:</p>
        <p>
          <strong>a. Informações fornecidas pelo usuário</strong>
        </p>
        <ul>
          <li>Nome completo</li>
          <li>Endereço de e-mail</li>
          <li>Número de telefone</li>
          <li>Dados de pagamento (criptografados via gateway de pagamento)</li>
        </ul>
        <p>
          <strong>b. Dados coletados automaticamente</strong>
        </p>
        <ul>
          <li>Endereço IP</li>
          <li>Tipo de dispositivo e sistema operacional</li>
          <li>Dados de uso do aplicativo (eventos, cliques, erros)</li>
          <li>Logs de atividades para segurança e auditoria</li>
        </ul>
        <p>
          <strong>c. Localização geográfica</strong>
        </p>
        <ul>
          <li>Geolocalização precisa (GPS) em primeiro plano e, com a permissão do usuário, em segundo plano, para sugerir vagas próximas, calcular rotas e estimar tempo e otimizar a experiência de reserva</li>
        </ul>
        <p>O usuário pode desativar o rastreamento de localização a qualquer momento pelas configurações do seu dispositivo.</p>
      </div>
      <div>
        <h3>4. DAS FINALIDADES DE USO DOS DADOS DOS USUÁRIOS</h3>
        <p>A coleta e o armazenamento dos dados cadastrais/pessoais dos usuários pela plataforma Parko têm por finalidades:</p>
        <ol type="I">
          <li>Permitir o acesso do usuário a conteúdos básicos da plataforma, exclusivo para usuários cadastrados, dentre eles o gerenciamento das reservas de vagas e dos pagamentos e as avaliações/feedbacks sobre a experiência do usuário na utilização da plataforma.</li>
          <li>Garantir o bem-estar do usuário, aprimorando, o serviço oferecido, facilitando, agilizando e cumprindo os compromissos estabelecidos entre a plataforma e a empresa contratada e plataforma e o usuário.</li>
          <li>Melhorar a plataforma a partir da compreensão de como o usuário utiliza o serviço fornecido, para ajudar no desenvolvimento de negócios e técnicas, a partir da sistemática de aprovação sobre a sua experiência com o uso do aplicativo.</li>
          <li>Oferecer vagas disponíveis próximas a você</li>
          <li>Realizar reservas e processar pagamentos</li>
          <li>Enviar notificações sobre status da reserva, atualizações ou promoções</li>
          <li>Melhorar a segurança do app</li>
          <li>Cumprir obrigações legais e regulatórias</li>
        </ol>
        <p>O tratamento de dados pessoais para finalidades não previstas nesta Política de Privacidade somente ocorrerá mediante comunicação prévia ao usuário, de modo que os direitos e obrigações aqui previstos permanecem aplicáveis.</p>
      </div>
      <div>
        <h3>5. DO PERÍODO DE ARMAZENAMENTO DOS DADOS DOS USUÁRIOS</h3>
        <p>O tempo de armazenamento dos dados do usuário pela plataforma Parko é determinado pelo período necessário para a prestação do serviço pela Pessoa Jurídica ou pelo cumprimento das finalidades previstas na cláusula 4 do presente documento.</p>
        <p>Os dados podem ser removidos pelo próprio usuário caso este deseje desativar a sua conta a qualquer momento.</p>
      </div>
      <div>
        <h3>6. DO COMPARTILHAMENTO  DOS DADOS DOS USUÁRIOS</h3>
        <p>Ao conceder seus dados pessoais à plataforma Parko, o cliente B2C e B2B devem estar de acordo com tal, na medida em que esses dados serão utilizados na constituição do aplicativo, exemplo de clientes na carta de serviços e na constituição do perfil dos usuários </p>
      </div>
      <div>
        <h3>7. DA TRANSFERÊNCIA DOS DADOS DOS USUÁRIOS A TERCEIROS</h3>
        <p>Poderão ser utilizados dados dos usuários B2B na formação do aplicativo, em processos de feedback, utilização como exemplo na carta de serviços da Parko e do cliente B2C e na constituição do perfil do usuário para utilização do aplicativo. </p>
        <p>Poderão ser compartilhados seus dados com:</p>
        <ul>
          <li><strong>Provedores de pagamento</strong></li>
          <li><strong>Serviços de geolocalização e mapas</strong></li>
          <li><strong>Plataformas de analytics</strong> para melhoria da experiência</li>
          <li><strong>Serviços de hospedagem em nuvem</strong></li>
        </ul>
        <p>Todos os parceiros estão comprometidos com a proteção de dados pessoais e atuam como operadores sob nossa orientação.</p>
        <p><strong>Não vendemos dados pessoais a terceiros.</strong></p>
      </div>
      <div>
        <h3>8. TRANSFERÊNCIA INTERNACIONAL DE DADOS</h3>
        <p>Os dados dos usuários podem ser transferidos para servidores localizados fora do Brasil com garantias adequadas de proteção (por exemplo, cláusulas contratuais padrão).</p>
      </div>
      <div>
        <h3>9. SEGURANÇA DOS DADOS</h3>
        <p>A plataforma Parko toma medidas técnicas e organizacionais para proteger suas informações, incluindo:</p>
        <ul>
          <li>Criptografia de dados em trânsito e em repouso</li>
          <li>Autenticação segura</li>
          <li>Monitoramento contínuo contra acessos não autorizados</li>
        </ul>
      </div>
      <div>
        <h3>10. RETENÇÃO E EXCLUSÃO DOS DADOS</h3>
        <p>Os dados dos usuários serão mantidos:</p>
        <ul>
          <li>Enquanto durar sua relação conosco</li>
          <li>Pelo tempo necessário para fins legais ou de auditoria (ex: transações financeiras)</li>
        </ul>
        <p>O usuário pode solicitar a exclusão dos seus dados a qualquer momento, conforme descrito na seção 11.</p>
      </div>
      <div>
        <h3>11. DIREITOS COMO TITULAR DE DADOS</h3>
        <p>O usuário, titular dos dados, pode exercer os seguintes direitos:</p>
        <ul>
          <li>Acesso aos seus dados</li>
          <li>Correção de informações incompletas ou desatualizadas</li>
          <li>Exclusão ou anonimização</li>
          <li>Portabilidade para outro serviço</li>
          <li>Revogação de consentimento</li>
          <li>Informação sobre compartilhamento</li>
        </ul>
        <p>Para exercer qualquer desses direitos, entre em contato pelo e-mail:<strong>suporte@parkoapp.com.br</strong>.</p>
      </div>
      <div>
        <h3>12. DO CONSENTIMENTO</h3>
        <p>Ao utilizar os serviços e fornecer as informações pessoais na plataforma, o usuário está consentindo com a presente Política de Privacidade do aplicativo. </p>
        <p>O usuário, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de cancelar seu cadastro, acessar e atualizar seus dados pessoais e garante a veracidade das informações por ele disponibilizadas.</p>
        <p>Será solicitado o consentimento explícito do usuário para:</p>
        <ul>
          <li>Acesso à sua localização em tempo real</li>
          <li>Envio de notificações push</li>
          <li>Uso de dados para fins de marketing (opcional)</li>
        </ul>
        <p>O usuário tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve entrar em contato através do e-mail: <strong><a href="mailto:suporte@parkoapp.com.br" target="_blank" className="mail-parko">suporte@parkoapp.com.br</a>.</strong></p>
      </div>
      <div>
        <h3>13. PRIVACIDADE INFANTIL</h3>
        <p>Este aplicativo não se destina a menores de 13 anos. Não coletamos intencionalmente dados pessoais de crianças. Se identificarmos tal coleta, os dados serão removidos imediatamente.</p>
      </div>
      <div>
        <h3>14. DAS ALTERAÇÕES</h3>
        <p>Reservamos o direito de modificar essa Política de Privacidade a qualquer momento, então, é recomendável que o usuário revise-a com frequência.</p>
        <p>As alterações e esclarecimentos vão surtir efeito imediatamente após sua publicação na plataforma. Quando realizadas alterações os usuários serão notificados via e-mail ou pela própria plataforma. Ao utilizar o serviço ou fornecer informações pessoais após eventuais modificações, o usuário demonstra sua concordância com as novas normas.</p>
        <p>Diante da fusão ou venda da plataforma à outra empresa os dados dos usuários podem ser transferidos para os novos proprietários para que a permanência dos serviços oferecidos.
        </p>
      </div>
      <div>
        <h3>15. DO FORO</h3>
        <p>Para a solução de controvérsias decorrentes do presente instrumento será aplicado integralmente o Direito brasileiro.
        </p>
        <p>Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra a sede da empresa.
        </p>
      </div>
      <div>
        <h3>16. CONTATO</h3>
        <p>Dúvidas ou solicitações sobre esta política podem ser encaminhadas para:</p>
        <p>📧 <strong><a className="color-black" href="mailto:suporte@parkoapp.com.br" target="_blank">suporte@parkoapp.com.br</a>.</strong></p>
        <p>🏢 <strong>PARKO SOLUCOES TECNOLOGICAS LTDA</strong> - Doutor José Peroba, 297, Edif. Atlanta Empresarial Sala 1105, Stiep, CEP 41.770-235, Salvador-BA</p>
      </div>
    </div>
  )
}

export default App
